// homeScreen.js
// -----------------------------------------------------------------------------
// Which app a phone's "Add to Home Screen" makes of this site.
//
// One build serves two installable apps: the driver app (public/manifest.json,
// opens the PIN pad) and the staff/shop app (public/manifest-staff.json, opens
// '/', which the login route sends on to each role's own home). A phone reads
// the manifest -- and on iOS the apple-mobile-web-app-title -- that the page
// links AT THE MOMENT the shortcut is added, so the link has to follow the
// route. With the driver manifest linked everywhere, a shop that added the site
// got an icon named คนขับ that opened the PIN pad.
//
// public/index.html makes the same choice from location.hash before the app
// loads, so the first manifest the browser fetches is already the right one;
// App.vue calls apply() on every route change after that.
//
// manifest.json must not change: an installed Android app is tied to its
// manifest, and drivers already have this one on their phones. The staff
// manifest carries its own `id` (and a query on its start_url) because a
// manifest's id ignores the #fragment -- without them both apps would share the
// id `index.html`, and Chrome could update an installed driver app from the
// staff manifest.
// -----------------------------------------------------------------------------

const DRIVER = { manifest: 'manifest.json', title: 'คนขับ' }
const STAFF = { manifest: 'manifest-staff.json', title: 'Delivery Kiosk' }

// '/driver' itself or anything under '/driver/' -- not a future '/driverreport'.
function isDriverPath (path) {
  const p = String(path || '')
  return p === '/driver' || p.indexOf('/driver/') === 0
}

function appFor (path) {
  return isDriverPath(path) ? DRIVER : STAFF
}

// Points the page's manifest link and iOS title at the app for `path`. Keeps
// the link's own directory, so it works under /delivery/ on IIS and / on
// Firebase alike, and touches nothing that is already right -- rewriting the
// href makes the browser fetch the manifest again.
function apply (doc, path) {
  const app = appFor(path)
  const link = doc.querySelector('link[rel="manifest"]')
  if (link) {
    const href = link.getAttribute('href') || ''
    const next = href.replace(/[^/]*$/, '') + app.manifest
    if (href !== next) link.setAttribute('href', next)
  }
  const title = doc.querySelector('meta[name="apple-mobile-web-app-title"]')
  if (title && title.getAttribute('content') !== app.title) {
    title.setAttribute('content', app.title)
  }
}

module.exports = { DRIVER, STAFF, isDriverPath, appFor, apply }
